var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      class: { "boss-table-4-selected": !_vm.entryObject.entry.isRead },
      attrs: { "data-test": "tr-show" },
    },
    [
      _c(
        "td",
        {
          staticClass: "boss-center pega-input",
          attrs: { "data-test": "check" },
          on: {
            click: function ($event) {
              _vm.entryObject.isChecked = !_vm.entryObject.isChecked
              _vm.updateChecked()
            },
          },
        },
        [
          _c("input", {
            staticClass: "boss-input-checkbox",
            attrs: { "data-role": "select-user", type: "checkbox" },
            domProps: { checked: _vm.entryObject.isChecked },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "boss-center boss-table-4-link-cell" },
        [
          _c(
            "router-link",
            {
              staticClass: "boss-table-4-link",
              attrs: {
                to: {
                  name: "entryDetail",
                  params: {
                    entryId: _vm.entryObject.entry.id,
                    tabKey: "resume",
                  },
                },
                "data-test": "date",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.entryDate) + "\n      "),
              _c("div", { attrs: { "data-test": "time" } }, [
                _vm._v("\n        " + _vm._s(_vm.entryTime) + "\n      "),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "boss-center" },
        [
          _c(
            "router-link",
            {
              staticClass: "boss-table-4-link boss-table-4-link-has-mark",
              attrs: {
                to: {
                  name: "entryDetail",
                  params: {
                    entryId: _vm.entryObject.entry.id,
                    tabKey: "resume",
                  },
                },
                "data-test": "user-id",
              },
            },
            [
              _vm._v(
                "\n      ID:" +
                  _vm._s(_vm.entryObject.entry.user.id) +
                  "\n      "
              ),
              _vm.entryObject.entry.user.isWithdrawal
                ? _c("span", { attrs: { "data-test": "withdrawal" } }, [
                    _vm._v("（途中退会）"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.entryObject.entry.user.isDuplicatedEntries
                ? _c("span", [
                    _c("br"),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content:
                                "別職種での応募や、過去1年以内の掲載時に応募があった場合に表示されます。",
                              trigger: "hover",
                            },
                            expression:
                              "{ content: '別職種での応募や、過去1年以内の掲載時に応募があった場合に表示されます。', trigger: 'hover' }",
                          },
                        ],
                        staticClass: "boss-status-label",
                        attrs: { "data-test": "duplicate" },
                      },
                      [_vm._v("重複応募")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "pega-pre-wrap",
                attrs: { "data-test": "member-name" },
                domProps: { textContent: _vm._s(_vm.memberName) },
              }),
              _vm._v(" "),
              _c("div", { attrs: { "data-test": "member-summary" } }, [
                _vm._v("\n        " + _vm._s(_vm.memberSummary) + "\n      "),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "is-boss-only-pc" },
        [
          _c(
            "router-link",
            {
              staticClass: "boss-table-4-link",
              attrs: {
                to: {
                  name: "entryDetail",
                  params: {
                    entryId: _vm.entryObject.entry.id,
                    tabKey: "resume",
                  },
                },
                "data-test": "job-id",
              },
            },
            [
              _vm._v(
                "\n      求人ID:" +
                  _vm._s(_vm.entryObject.entry.job.id) +
                  "\n      "
              ),
              _c("div", { attrs: { "data-test": "job-name" } }, [
                _vm._v("\n        " + _vm._s(_vm.jobName) + "\n      "),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("td", { staticClass: "boss-center" }, [
        _c("div", { staticClass: "boss-layout boss-layout-vertical" }, [
          _c("div", [
            _c("div", { staticClass: "boss-layout boss-layout-gap-small" }, [
              _vm.entryObject.entry.approachingStatus.scout.isSend
                ? _c("div", [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content: _vm.entryObject.entry.approachingStatus
                                .scout.isEffective
                                ? ""
                                : _vm.expiredMessage,
                            },
                            expression:
                              "{ content:entryObject.entry.approachingStatus.scout.isEffective ? '' : expiredMessage }",
                          },
                        ],
                        staticClass: "pega-scout-label",
                        attrs: {
                          disabled:
                            !_vm.entryObject.entry.approachingStatus.scout
                              .isEffective,
                          "data-test": "scout-label",
                        },
                      },
                      [_vm._v("スカウト")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.entryObject.entry.approachingStatus.offerDm.isSend
                ? _c("div", [
                    _c("img", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: {
                            content: _vm.entryObject.entry.approachingStatus
                              .offerDm.isEffective
                              ? "オファーDM"
                              : _vm.expiredMessage,
                          },
                          expression:
                            "{ content:entryObject.entry.approachingStatus.offerDm.isEffective ? 'オファーDM' : expiredMessage }",
                        },
                      ],
                      class: {
                        "boss-icon-end":
                          !_vm.entryObject.entry.approachingStatus.offerDm
                            .isEffective,
                      },
                      attrs: {
                        src: require("@/assets/images/icon-offer-dm.svg"),
                        "data-test": "dm-icon",
                      },
                    }),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "boss-layout boss-layout-vertical boss-layout-no-gap",
              },
              _vm._l(
                _vm.entryObject.entry.approachingStatus.specialFavors,
                function (sendingFavor) {
                  return _c("div", { key: sendingFavor.id }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content: _vm.getSpecialFavorTooltip(sendingFavor),
                            },
                            expression:
                              "{ content: getSpecialFavorTooltip(sendingFavor)}",
                          },
                        ],
                        staticClass:
                          "boss-bonus-check-text boss-bonus-check-text-gap-small boss-check-true",
                        class: { "boss-bonus-end": !sendingFavor.isEffective },
                        attrs: {
                          "data-test": "special-favor-" + sendingFavor.id,
                        },
                      },
                      [_vm._v(_vm._s(sendingFavor.name))]
                    ),
                  ])
                }
              ),
              0
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("message-icon-information", {
        attrs: {
          message: _vm.entryObject.entry.message,
          "entry-id": _vm.entryObject.entry.id,
          "is-entry-message-reservation-reserved":
            _vm.entryObject.entry.isEntryMessageReservationReserved,
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.displayItems, function (displayItem) {
        return [
          displayItem === "phase"
            ? _c(
                "td",
                {
                  key: "outline-" + displayItem,
                  staticClass: "boss-center is-boss-only-pc",
                  attrs: { "data-test": "phase" },
                },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.entryObject.entry.currentSelection.phaseId,
                          expression:
                            "entryObject.entry.currentSelection.phaseId",
                        },
                      ],
                      staticClass: "boss-input-select js-check-default",
                      attrs: {
                        "data-default": "",
                        "data-test": "selection-phase",
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.entryObject.entry.currentSelection,
                              "phaseId",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.updateSelectionPhase,
                        ],
                      },
                    },
                    _vm._l(_vm.phases, function (selectionPhase, i) {
                      return _c(
                        "option",
                        { key: i, domProps: { value: selectionPhase.id } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(selectionPhase.name) +
                              "\n        "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          displayItem === "status"
            ? _c(
                "td",
                {
                  key: "outline-" + displayItem,
                  staticClass: "is-boss-only-pc",
                  attrs: { "data-test": "status" },
                },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.entryObject.entry.currentSelection.statusId,
                          expression:
                            "entryObject.entry.currentSelection.statusId",
                        },
                      ],
                      staticClass: "boss-input-select js-check-default",
                      attrs: {
                        "data-default": "",
                        "data-test": "selection-status",
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.entryObject.entry.currentSelection,
                              "statusId",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.updateSelectionStatus,
                        ],
                      },
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v("\n          −\n        "),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.allStatuses, function (selectionStatus, i) {
                        return _c(
                          "option",
                          { key: i, domProps: { value: selectionStatus.id } },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(selectionStatus.name) +
                                "\n        "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          displayItem === "remarks"
            ? _c(
                "td",
                {
                  key: "outline-" + displayItem,
                  staticClass:
                    "is-boss-only-pc boss-table-cell-has-textarea pega-position-inherit",
                  attrs: { "data-test": "remarks" },
                },
                [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.entryObject.entry.remarks,
                        expression: "entryObject.entry.remarks",
                      },
                    ],
                    staticClass: "boss-textarea-in-table",
                    attrs: { rows: "5", "data-test": "text-remarks" },
                    domProps: { value: _vm.entryObject.entry.remarks },
                    on: {
                      change: _vm.updateRemarks,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.entryObject.entry,
                          "remarks",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          displayItem === "responsible_staffs"
            ? _c(
                "td",
                {
                  key: "outline-" + displayItem,
                  staticClass: "is-boss-only-pc",
                  attrs: { "data-test": "responsible-staffs" },
                },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.entryObject.entry.responsibleStaffId,
                          expression: "entryObject.entry.responsibleStaffId",
                          modifiers: { number: true },
                        },
                      ],
                      staticClass: "boss-input-select js-check-default",
                      attrs: { "data-test": "select-responsible-staffs" },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return _vm._n(val)
                              })
                            _vm.$set(
                              _vm.entryObject.entry,
                              "responsibleStaffId",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.updateResponsibleStaff,
                        ],
                      },
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v("\n          −\n        "),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.responsibles, function (staff) {
                        return _c(
                          "option",
                          { key: staff.id, domProps: { value: staff.id } },
                          [
                            _vm._v(
                              "\n          " + _vm._s(staff.name) + "\n        "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          displayItem === "evaluation"
            ? _c(
                "td",
                {
                  key: "outline-" + displayItem,
                  staticClass: "is-boss-only-pc",
                  attrs: { "data-test": "evaluation-name" },
                },
                [_vm._v("\n      " + _vm._s(_vm.evaluationName) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          displayItem === "comment"
            ? _c("td", {
                key: "outline-" + displayItem,
                staticClass: "is-boss-only-pc pega-pre-wrap",
                attrs: { "data-test": "evaluation-comment" },
                domProps: {
                  textContent: _vm._s(
                    _vm.entryObject.entry.currentSelection.evaluationComment ||
                      "−"
                  ),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          displayItem === "selection_date"
            ? _c(
                "td",
                {
                  key: "outline-" + displayItem,
                  staticClass: "is-boss-only-pc pega-pre-wrap text-center",
                  class: {
                    "notice-background": !_vm.entryObject.entry.recentSelection,
                  },
                  attrs: { "data-test": "selection-date" },
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "boss-table-4-link",
                      attrs: {
                        to: {
                          name: "entryDetail",
                          params: {
                            entryId: _vm.entryObject.entry.id,
                            tabKey: "selection",
                          },
                        },
                        "data-test": "selection-date-router",
                      },
                    },
                    [
                      _vm.entryObject.entry.recentSelection
                        ? _c("span", { staticClass: "pega-reminded-label" }, [
                            _c(
                              "div",
                              {
                                class: {
                                  "line-through display-inline": _vm.isReminded,
                                },
                                attrs: {
                                  "data-test": "selection-date-day-time",
                                },
                              },
                              [
                                _c("div", {
                                  attrs: { "data-test": "selection-date-day" },
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.recentSelectionDate
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  attrs: { "data-test": "selection-date-time" },
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.recentSelectionTime
                                    ),
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isReminded
                              ? _c("div", {
                                  staticClass: "text-nowrap",
                                  attrs: { "data-test": "reminded" },
                                  domProps: {
                                    textContent: _vm._s("リマインド済"),
                                  },
                                })
                              : _vm._e(),
                          ])
                        : _c("div", {
                            attrs: { "data-test": "selection-date-no-setting" },
                            domProps: { textContent: _vm._s("未設定") },
                          }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "boss-button boss-button-compact",
                          attrs: { "data-test": "selection-date-button" },
                          on: {
                            click: function ($event) {
                              return _vm.goToEntryDetailSelection()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "boss-button-text" }, [
                            _vm._v(_vm._s(_vm.recentSelectionButtonText)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showRemindIcon
                        ? _c(
                            "div",
                            {
                              staticClass: "pega-selection-bell-icon",
                              attrs: {
                                "data-test": "selection-date-remind-icon",
                              },
                            },
                            [
                              _c("span", {
                                staticClass: "boss-icon boss-icon-bell-solid",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }